<template>
  <div class="alert alert-light border">
    <button
      class="btn btn-link p-2 text-decoration-none d-flex align-items-center w-100"
      type="button"
      @click="schemaExpanded = !schemaExpanded"
      style="border-radius: 0.375rem;"
    >
      <font-awesome-icon icon="info-circle" class="me-2" />
      <h6 class="mb-0">Was ist ein Mitgliederfeld?</h6>
      <font-awesome-icon
        :icon="schemaExpanded ? 'chevron-up' : 'chevron-down'"
        class="ms-auto"
      />
    </button>
    <div v-show="schemaExpanded" class="mt-2">
      <p class="mb-2 small">
        Im Mitgliederfelder sind Mitgliederfelder definiert, das sind Informationen, die ein Admin von jedem Bereichs-Mitglied abfragt.
        Diese können optional oder verpflichtend sein. Du kannst verschiedene Feldtypen erstellen und festlegen,
        welche Felder Pflichtfelder sind.
      </p>
      <ul class="small mb-0">
        <li><strong>Feldname:</strong> Der Titel des Feldes (z.B. "Geburtsdatum", "Abteilung")</li>
        <li><strong>Feldtyp:</strong> Bestimmt die Art der Eingabe (Text, E-Mail, Datum, etc.)</li>
        <li><strong>Pflichtfeld:</strong> Legt fest, ob das Feld ausgefüllt werden muss</li>
        <li><strong>Beschreibung:</strong> Hilfstext für das Feld (bei Checkboxen wird dies als Label verwendet)</li>
        <li><strong>Platzhalter:</strong> Beispieltext, der im Eingabefeld angezeigt wird</li>
      </ul>
    </div>
    <div v-if="$slots.default && schemaExpanded" class="mt-3 text-center">
      <slot />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const schemaExpanded = ref(false)
</script>
